enum TileValueUnit {
  Millisecond = 'MILLISECOND',
  Ratio = 'RATIO',
  Number = 'NUMBER',
  Raw = 'RAW',
}

export default TileValueUnit
